import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * The last few questions asked of AI Search, offered back in the header search box.
 *
 * Per-browser, like RecentPagesStore: localStorage, wiped by `localStorage.clear()` on sign out,
 * so one person's questions (which can name patients) never show for the next.
 */
export const MAX_RECENT_QUESTIONS = 5;

type RecentQuestionsStore = {
  /** Newest first, no repeats. */
  questions: string[];
  recordQuestion: (question: string) => void;
};

export const useRecentQuestionsStore = create<RecentQuestionsStore>()(
  persist(
    set => ({
      questions: [],
      recordQuestion: raw =>
        set(state => {
          const question = raw.trim();
          if (!question) return state;

          // Asking again moves it to the front; "Which patients…" and "which patients…" are one question.
          const others = state.questions.filter(existing => existing.toLowerCase() !== question.toLowerCase());
          return { questions: [question, ...others].slice(0, MAX_RECENT_QUESTIONS) };
        })
    }),
    { name: 'aiSearchRecentQuestions', storage: createJSONStorage(() => localStorage) }
  )
);
